export const AUTHENTICATE = 'auth/AUTHENTICATE';
export const AUTHENTICATE_SUCCESS = 'auth/AUTHENTICATE_SUCCESS';
export const AUTHENTICATE_FAIL = 'auth/AUTHENTICATE_FAIL';

export const SET_PAYLOAD = 'auth/SET_PAYLOAD';
export const LOGOUT = 'auth/LOGOUT';

export const WS_AUTHENTICATED = 'server/auth/WS_AUTHENTICATED';



// WEBPACK FOOTER //
// ./src/redux/constants/auth.js